import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styles from './App.module.css';
import Gallery from './components/Gallery';

// ADD THESE IMPORTS
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Programs from './components/Programs';
import VisionMission from './components/VisionMission';
import CoreValues from './components/CoreValues';
import Contact from './components/Contact';
import SocialLinks from './components/SocialLinks';

function App() {
  return (
    <div className={styles.container}>
      <Header />
      <main className={styles.main}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/vision-mission" element={<VisionMission />} />
          <Route path="/core-values" element={<CoreValues />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
        <SocialLinks />
      </main>
      <Footer />
    </div>
  );
}

export default App;
